export const LOADING_MESSAGE = 'Loading your Push Notification...';
